import { ImageProps, ImageSourcePropType } from 'react-native';

import { DEVICE_TYPE } from '../../../../constants/layout';
import { DeviceType } from '../../../../types/Common';
import { FastImageSource } from '../../../Image/FastImage';
import { CoverSourceType } from '../../types';
import S from './style';

interface Props extends Omit<ImageProps, 'source'> {
  source?: CoverSourceType;
}

export default ({ source, ...others }: Props) => {
  if (!source) {
    return null;
  }

  const isImageRequireSource =
    typeof (source as ImageSourcePropType) === 'number';
  const isImageSource = !!(source as FastImageSource).uri;
  const useResponsiveImage = !(isImageRequireSource || isImageSource);
  const ImageComponent = useResponsiveImage ? S.ResponsiveImage : S.Image;
  let imageProps;

  if (useResponsiveImage) {
    imageProps = {
      sources: source,
      renderImageElement: props => <S.Image {...props} />,
      preferredPixelRatio: DEVICE_TYPE === DeviceType.DESKTOP ? 3 : undefined,
    };
  } else {
    imageProps = {
      source,
    };
  }

  return <ImageComponent {...imageProps} {...others} />;
};
